import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { changeSberMarket } from '../../../actions/sbermarket';
import MarketMegamarketApi from '../../../API/market/megamarket-api';
import { Column, Row, WhiteBlock } from '../../../components/Basic/Blocks';
import { Button, SendButton } from '../../../components/Basic/Buttons';
import { Content } from '../../../components/Basic/Global';
import { Select } from '../../../components/Basic/Inputs';
import MarketProvidersDateUpdate from '../../../components/Markets/Blocks/MarketProvidersDateUpdate';
import { MARKETS_MAP, MEGAMARKET_MARKETS_MAP, SBER_1, SBER_2, TYPE_BUTTONS } from '../../../constans';
import styles from './styles.module.scss';
import MegamarketTable from './Table';

const MegaMarketPage = () => {
  const dispatch = useDispatch();
  const shop = useSelector((store) => store.sbermarket.market);

  const [provider, changeProvider] = useState();
  const [providers, setProviders] = useState([]);
  const [providerData, setProviderData] = useState({ status_stock: '', date_stock_update: null });

  const allProviders = useSelector((store) => store.providers);
  const user = useSelector((store) => store.user);

  const updateProviderStocksAndPrice = async (providerId = undefined, isNullStock = false, offerIds = undefined) => {
    return await MarketMegamarketApi.updateStocksAndPrices({
      data: {
        shop: MARKETS_MAP[shop],
        filter: {
          providerId,
          offerIds,
        },
        rules: {
          nullProvider: isNullStock,
          nullWarehouse: isNullStock,
        },
      }
    });
  };

  const updateProviderPrice = async (providerId = undefined, offerIds = undefined) => {
    return await MarketMegamarketApi.updatePrices({
      data: {
        shop: MARKETS_MAP[shop],
        filter: {
          providerId,
          offerIds,
        },
      }
    });
  };

  useEffect(() => {
    const p = allProviders.filter((item) => !item['hide']);
    if (p.length > 0) {
      setProviders(p);
      changeProvider(p[0] || {});
    } else {
      changeProvider({ name: '' });
    }
  }, [allProviders]);

  useEffect(() => {
    if (provider) {
      setProviderData(provider.markets_update[MEGAMARKET_MARKETS_MAP[shop]]);
    }
  }, [provider, shop]);

  const isOwner = user.role === 'owner' || user.role === 'admin';

  return (
    <>
      <Content>
        <WhiteBlock title="Управление" title_bold={`МегаМаркет`} style={{ margin: '10px 0' }} minimize={true}>
          <Row style={{ alignItems: 'stretch' }}>
            <Column style={{ marginRight: '15px' }} className={styles.main_block}>
              <Row>
                <Select
                  label="Магазин"
                  select={shop}
                  width="200px"
                  style={{ marginBottom: '10px' }}
                  list={[SBER_1, SBER_2]}
                  onSelect={(v) => dispatch(changeSberMarket(v))}
                />
              </Row>

              {isOwner && (
                <Row style={{ alignItems: 'flex-start' }}>
                  <SendButton
                    sendData={{ data: { shop: MARKETS_MAP[shop] } }}
                    sendApi={MarketMegamarketApi.updateByExcel}
                    style={{ marginRight: "10px" }}
                  >
                    Подгрузить данные
                  </SendButton>
                  <SendButton
                    sendData={{ data: { shop: MARKETS_MAP[shop] } }}
                    sendApi={MarketMegamarketApi.saveCommission}
                  >
                    Подгрузить габариты и комиссии
                  </SendButton>
                </Row>
              )}
            </Column>

            {isOwner && (
              <Column className={styles.stosks_column} style={{ marginRight: '15px' }}>
                <Row style={{ alignItems: 'flex-end' }}>
                  <Select
                    label="Поставщик"
                    select={provider}
                    valueFn={(p) => p.name}
                    list={providers}
                    onSelect={(v) => changeProvider(v)}
                    width={'200px'}
                  />

                  {isOwner && (
                    <Button
                      type={TYPE_BUTTONS.WHITE}
                      style={{ marginLeft: '15px' }}
                      onClick={() => MarketMegamarketApi.updateFeed({ data: { shop: MARKETS_MAP[shop], providerId: provider.id } })}
                    >
                      Обновить фид
                    </Button>
                  )}
                </Row>
                <Row style={{ marginTop: '10px', width: '100%' }}>
                  <Button
                    type={TYPE_BUTTONS.BLUE}
                    onClick={() => updateProviderStocksAndPrice(provider.id)}
                    style={{ marginRight: '15px' }}
                    disabled={true}
                  >
                    Обновить остатки и цены
                  </Button>
                  <Button type={TYPE_BUTTONS.RED} onClick={() => updateProviderStocksAndPrice(provider.id, true)} disabled={true}                  >
                    Обнулить остатки
                  </Button>

                  {isOwner && (
                    <Row>
                      <Button
                        type={TYPE_BUTTONS.WHITE}
                        onClick={() => updateProviderPrice(provider.id)}
                        style={{ marginLeft: '15px' }}
                      >
                        Пересчитать цены
                      </Button>
                    </Row>
                  )}
                </Row>
                <MarketProvidersDateUpdate providerData={providerData} />
              </Column>
            )}
          </Row>
        </WhiteBlock>

        <MegamarketTable
          updateProviderStocksAndPrice={updateProviderStocksAndPrice}
          updateProviderPrice={updateProviderPrice}
        />
      </Content>
    </>
  );
};

export default MegaMarketPage;
